import { type NavTabDescriptor } from './DesktopNav/NavTab';

/**
 * Shared visibility rule for experimental nav tabs. Both the legacy icon rail
 * and the sidebar consume this so they never diverge.
 */
export function shouldShowNavTab(
  tab: NavTabDescriptor,
  showExperimentalFeatures: boolean,
  isTestUser: boolean,
): boolean {
  // Experimental items require both the preference and a test-user session.
  if (tab.experimental && (!showExperimentalFeatures || !isTestUser)) {
    return false;
  }
  return !!tab.show;
}
